/**
 * Can the current browser read from clipboard
 *
 * @returns {boolean} true if can read from clipboard, otherwise false
 */
export default function useCanReadClipboard() {
  // using harsh detection - only browsers which support the latest api
  return typeof (navigator.clipboard || {}).readText === 'function';
}
